var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button, Flex, Tooltip } from '@robinpowered/ui-kit';
import { useMemo, useState } from 'react';
import moment from 'moment';
import { useConfig } from '../../context/ConfigContext';
import queryString from 'query-string';
import { useFeatureFlags } from '@robinpowered/dashboard-apps-common';
import { useEventDetailContext } from '../context/EventDetailContextProvider';
import { useUserPermissions } from '../../hooks/useUserPermissions';
import { useTranslation } from 'react-i18next';
import { useEditFooterMatrix, } from '../hooks/useEditFooterMatrix';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
var DISABLED_TOOLTIP_KEYS = {
    isRedirectingToOldComposer: 'eventDetails.footer.edit_tooltip_disabled_redirecting',
    pastEvent: 'eventDetails.footer.edit_tooltip_disabled_past_event',
    notRobinEventAndCannotEditSynced: 'eventDetails.footer.edit_tooltip_disabled_not_robin',
    noUserPermissionAndNoManagePermission: 'eventDetails.footer.edit_tooltip_disabled_no_permission',
};
var creationType = {
    MANUAL: 'manual',
    AUTO: 'auto',
};
export var FooterButtons = function (_a) {
    var _b, _c, _d;
    var onClickEdit = _a.onClickEdit;
    var t = useTranslation('meetingRooms').t;
    var environmentUrls = useConfig().environmentUrls;
    var dashboardUrl = environmentUrls.dashboardUrl;
    var currentOrg = useUserPermissions().currentOrg;
    var _e = useEventDetailContext(), event = _e.event, spaceData = _e.spaceData, canEditSyncedEvents = _e.canEditSyncedEvents, timezone = _e.timezone, setShowDeleteModal = _e.setShowDeleteModal, parsedDateTime = _e.parsedDateTime;
    var spaces = useMemo(function () { return Array.from(spaceData.values()); }, [spaceData]);
    var _f = __read(useState(false), 2), isRedirectingToOldComposer = _f[0], setIsRedirectingToOldComposer = _f[1];
    var redirectToOldComposer = function () {
        var _a;
        if (!event)
            return;
        setIsRedirectingToOldComposer(true);
        var queryParams = {
            title: event.title,
            org: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id,
            started_at: event.start.date_time,
            ended_at: event.end.date_time,
            space_id: event.space_id,
            redirectTo: window.location.href,
            inviteeCount: (_a = event.reservation_approval) === null || _a === void 0 ? void 0 : _a.invitee_count,
            timezone: timezone || moment.tz.guess(),
            isAllDay: !!event.is_all_day,
        };
        window.location.href = "".concat(dashboardUrl, "/event-composer/").concat(event === null || event === void 0 ? void 0 : event.id, "?").concat(queryString.stringify(queryParams));
    };
    var _g = useFeatureFlags(), checkFlag = _g.checkFlag, featureFlagsLoading = _g.loading;
    var showNewEventComposer = checkFlag('hydra(new-event-composer)') && !featureFlagsLoading;
    var isRobinEvent = (event === null || event === void 0 ? void 0 : event.creation_type) === creationType.MANUAL ||
        (event === null || event === void 0 ? void 0 : event.creation_type) === creationType.AUTO;
    var isPastEvent = parsedDateTime
        ? parsedDateTime.endTime.isBefore(moment.now())
        : false;
    /* Main space on the event */
    var space = useMemo(function () { return spaces.find(function (space) { return Number(space.id) === (event === null || event === void 0 ? void 0 : event.space_id); }); }, [spaces, event === null || event === void 0 ? void 0 : event.space_id]);
    var hasEventsManagePermission = !!((_b = space === null || space === void 0 ? void 0 : space.permissions) === null || _b === void 0 ? void 0 : _b['events:manage']);
    var _h = useEditFooterMatrix({
        event_permissions: event === null || event === void 0 ? void 0 : event.event_permissions,
        isPastEvent: isPastEvent,
        isRobinEvent: isRobinEvent,
        canEditSyncedEvents: canEditSyncedEvents,
        hasEventsManagePermission: hasEventsManagePermission,
        isRedirectingToOldComposer: isRedirectingToOldComposer,
    }), updateAsSpace = _h.updateAsSpace, isEditButtonDisabled = _h.isEditButtonDisabled, deleteAsSpace = _h.deleteAsSpace, isDeleteButtonDisabled = _h.isDeleteButtonDisabled, primaryEditDisabledReason = _h.primaryEditDisabledReason, primaryCancelDisabledReason = _h.primaryCancelDisabledReason;
    return (_jsxs(DrawerFooter, { children: [_jsx(Tooltip, { title: isEditButtonDisabled && primaryEditDisabledReason
                    ? t(DISABLED_TOOLTIP_KEYS[primaryEditDisabledReason])
                    : updateAsSpace && !((_c = event === null || event === void 0 ? void 0 : event.event_permissions) === null || _c === void 0 ? void 0 : _c.update)
                        ? t('eventDetails.footer.edit_tooltip_space')
                        : null, children: _jsx(Button, { type: "default", size: "large", disabled: isEditButtonDisabled, onClick: function () {
                        if (showNewEventComposer) {
                            // @TODO this should be controlled by the event composer in the future
                            onClickEdit((event === null || event === void 0 ? void 0 : event.id) || '');
                        }
                        else {
                            redirectToOldComposer();
                        }
                    }, style: { flex: 1 }, children: t('eventDetails.footer.edit') }) }), _jsx(Tooltip, { title: isDeleteButtonDisabled && primaryCancelDisabledReason
                    ? t(DISABLED_TOOLTIP_KEYS[primaryCancelDisabledReason])
                    : deleteAsSpace && !((_d = event === null || event === void 0 ? void 0 : event.event_permissions) === null || _d === void 0 ? void 0 : _d.cancel)
                        ? t('eventDetails.footer.cancel_tooltip_space')
                        : null, children: _jsx(Button, { disabled: isDeleteButtonDisabled, size: "large", danger: true, onClick: function () {
                        setShowDeleteModal(true);
                    }, style: { flex: 1 }, children: t('eventDetails.footer.delete') }) }), (event === null || event === void 0 ? void 0 : event.id) && (_jsx(Button, { size: "large", onClick: function () {
                    window.open("".concat(dashboardUrl, "/events/").concat(event.id), '_blank', 'noopener,noreferrer');
                }, icon: _jsx(FontAwesomeIcon, { icon: faUpRightFromSquare }) }))] }));
};
var DrawerFooter = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* @TODO update this */\n  border-top: 1px solid ", ";\n\n  padding: 16px;\n  gap: 16px;\n"], ["\n  /* @TODO update this */\n  border-top: 1px solid ", ";\n\n  padding: 16px;\n  gap: 16px;\n"])), '#DCDADA');
var templateObject_1;
